'use client';

import { productCardType, ResponseType, serviceType, shop } from '@/commonTypes';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React, { useEffect, useState } from 'react';
import ShopHero from './ShopHero';
import ShopMenuSection from './ShopMenuSection';
import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import ShopSideInfo from './ShopSideInfo';
import ShopMenuContent from './ShopMenuContent';
import { mockShop } from '@/mock/sample.json';

interface propsType {
  data?: shop;
  similarItems?: shop[];
  section?: string;
  products: ResponseType<productCardType>;
  services: ResponseType<serviceType>;
  page?: string | number | null;
  limit?: number;
  params?: any;
}

export default function SingleShopContent({
  data,
  similarItems = [],
  section,
  page,
  limit = 10,
  params,
  products,
  services,
}: propsType) {
  const tCommon = useTranslations('common');
  const info = mockShop;
  const [activeMenu, setActiveMenu] = useState<string | number>(section ? section : 'product');
  const [pageNumber, setPageNumber] = useState<number | string>(page ? Number(page) : 1);
  const [list, setList] = useState<
    ResponseType<productCardType> | ResponseType<serviceType> | null
  >();
  useEffect(() => {
    if (activeMenu == 'product') {
      setList(products);
    }
    if (activeMenu == 'service') {
      setList(services);
    }
  }, [activeMenu, products, services]);

  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);
  useEffect(() => {
    setActiveMenu(section ? section : 'product');
  }, [section]);
  // const onclickMenu = (x: number | string | undefined) => {
  //   x && setActiveMenu(x);
  // };
  console.log('section==', section, activeMenu, products, services);
  const menu = [
    {
      id: 'product',
      title: 'کالاها',
      // onClick: () => onclickMenu(1),
      href: `/shops/${info?.slug}?section=product`,
      icon: (
        <MainIcons.basketIcon
          width="15px"
          height="15px"
          fill={activeMenu == 'product' ? ' var(--text-dark)' : 'var(--text-mut)'}
        />
      ),
      count: products?.response_details?.count,
    },
    {
      id: 'service',
      title: 'خدمات قابل رزرو',
      // onClick: () => onclickMenu(2),
      href: `/shops/${info?.slug}?section=service`,
      icon: (
        <MainIcons.ServiceIcon
          width="15px"
          height="15px"
          fill={activeMenu == 'service' ? 'var(--text-dark)' : ' var(--text-mut)'}
        />
      ),
      count: services?.response_details?.count,
    },
    {
      id: 'about',
      title: 'درباره فروشگاه',
      // onClick: () => onclickMenu(3),
      href: `/shops/${info?.slug}?section=about`,
      icon: (
        <MainIcons.shopIcon
          width="15px"
          height="15px"
          fill={activeMenu == 'about' ? 'var(--text-dark)' : 'var(--text-mut)'}
        />
      ),
    },
    {
      id: 'comment',
      title: 'نظرات',
      href: `/shops/${info?.slug}?section=comment`,
      // onClick: () => onclickMenu("comment"),
      icon: (
        <MainIcons.starIcon
          width="15px"
          height="15px"
          fill={activeMenu == 'comment' ? 'var(--text-dark)' : ' var(--text-mut)'}
        />
      ),
      count: info?.commentsCount,
    },
  ];

  console.log('shop=======', info, info?.closestTime);
  console.log('products=======', products, list, activeMenu);
  return (
    <>
      <PageWrapper className={`p-0 section-light`}>
        <ViewportWrapper className={`pb-0 w-full `}>
          <ShopHero shop={info} />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`p-0 section-paper mt-0`}>
        <ViewportWrapper className={`py-0 container `}>
          <ShopMenuSection menu={menu} activeMenu={activeMenu} />
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`p-0 section-light mt-0`}>
        <ViewportWrapper className={` container `}>
          <div className={`${styles.grid}`}>
            <ShopMenuContent
              activeMenu={activeMenu}
              list={list}
              setList={setList}
              params={params}
              page={page}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              limit={limit}
              shop={info}
            />
            <ShopSideInfo shop={info} />
          </div>
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
